var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000063",
    fillRule: "evenodd",
    d: "M54 34.7c-.6.5-1.1 1.8-2.7 1.8-3.2 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.2 0-4-2.7-6.4-2.7-1.6 0-2.3 2.7-4 2.7-3.1 0-3.9-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.1 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.2 0-4-2.7-6.3-2.7-1.6 0-2 2-3 2v3.4c1 0 1.4-1.9 3-1.9C6 37.3 6.9 40 10 40c1.6 0 2.4-2.7 4-2.7 2.4 0 3.2 2.7 6.4 2.7 1.5 0 2.3-2.7 4-2.7 2.3 0 3 2.7 6.3 2.7 1.6 0 2.3-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.4-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.1-.8 2.7-1.3zm0-6.8c-.6.6-1.1 1.9-2.7 1.9-3.2 0-4-2.8-6.3-2.8-1.6 0-2.4 2.8-4 2.8-3.2 0-4-2.8-6.4-2.8-1.6 0-2.3 2.8-4 2.8-3.1 0-3.9-2.8-6.3-2.8-1.6 0-2.4 2.8-4 2.8-3.1 0-4-2.8-6.3-2.8-1.6 0-2.4 2.8-4 2.8-3.2 0-4-2.8-6.3-2.8-1.6 0-2 2-3 2v3.5c1 0 1.4-2 3-2 2.4 0 3.2 2.7 6.3 2.7 1.6 0 2.4-2.7 4-2.7 2.4 0 3.2 2.7 6.4 2.7 1.5 0 2.3-2.7 4-2.7 2.3 0 3 2.7 6.3 2.7 1.6 0 2.3-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.4-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.1-.7 2.7-1.3zm0-6.7c-.6.5-1.1 1.8-2.7 1.8-3.2 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.2 0-4-2.7-6.4-2.7-1.6 0-2.3 2.7-4 2.7-3.1 0-3.9-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.1 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.2 0-4-2.7-6.3-2.7-1.6 0-2 2-3 2v3.4c1 0 1.4-2 3-2 2.4 0 3.2 2.8 6.3 2.8 1.6 0 2.4-2.7 4-2.7 2.4 0 3.2 2.7 6.4 2.7 1.5 0 2.3-2.7 4-2.7 2.3 0 3 2.7 6.3 2.7 1.6 0 2.3-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.4-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.1-.8 2.7-1.3zm0-6.8c-.6.5-1.1 1.8-2.7 1.8-3.2 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.2 0-4-2.7-6.4-2.7-1.6 0-2.3 2.7-4 2.7-3.1 0-3.9-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.1 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.2 0-4-2.7-6.3-2.7-1.6 0-2 2-3 2v3.4c1 0 1.4-1.9 3-1.9 2.4 0 3.2 2.7 6.3 2.7 1.6 0 2.4-2.7 4-2.7 2.4 0 3.2 2.7 6.4 2.7 1.5 0 2.3-2.7 4-2.7 2.3 0 3 2.7 6.3 2.7 1.6 0 2.3-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.4-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.1-.8 2.7-1.3zm0-6.8c-.6.6-1.1 1.9-2.7 1.9-3.2 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.2 0-4-2.7-6.4-2.7-1.6 0-2.3 2.7-4 2.7-3.1 0-3.9-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.1 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.2 0-4-2.7-6.3-2.7-1.6 0-2 1.9-3 1.9v3.5c1 0 1.4-2 3-2C6 10.3 6.9 13 10 13c1.6 0 2.4-2.7 4-2.7 2.4 0 3.2 2.7 6.4 2.7 1.5 0 2.3-2.7 4-2.7 2.3 0 3 2.7 6.3 2.7 1.6 0 2.3-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.4-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.1-.8 2.7-1.4zM54 1c-.6.5-1.1 1.8-2.7 1.8-3.2 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.2 0-4-2.7-6.4-2.7-1.6 0-2.3 2.7-4 2.7-3.1 0-3.9-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7-3.1 0-4-2.7-6.3-2.7-1.6 0-2.4 2.7-4 2.7C6.8 2.7 6 0 3.7 0c-1.6 0-2 2-3 2v3.4c1 0 1.4-1.9 3-1.9C6 3.5 6.9 6.2 10 6.2c1.6 0 2.4-2.7 4-2.7 2.4 0 3.2 2.7 6.4 2.7 1.5 0 2.3-2.7 4-2.7 2.3 0 3 2.7 6.3 2.7 1.6 0 2.3-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.4-2.7 4-2.7 2.3 0 3.1 2.7 6.3 2.7 1.6 0 2.1-.8 2.7-1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a24300",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "M40.2 11 40 38.4c0 1.4 1.4 1.4 1.5 0L41 11z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.2,
    d: "m43.2 21.2-.9-1-.2 1-.4-1.5-.4.8v-1.6l-.4.7v-1.5l-.4.7-.2-1.8-.4.7-.2-1.8-.4.7-.2-1.8-.1-.9.2-.3.4.1.8.8 1.5 1.4-1-.4 1.6 1.5-1-.4 1.6 1.5-1-.4 1.4 1.2-1-.4 1.5 1.2-1-.3 1 1.2-1-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.2 21.2-4-7.6m2.7 2.3-2.1-1.3-.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5 17-2.2-1.3-.4 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 18-2-1.2-.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.5 18.9-2-1-.6 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 19.7-2-1-.7 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 20.6-1.8-1.3-.1 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "m32.6 8.2 1.5.5-.5-1.1L35 8.9v-1l1 1.6-.2-1 1 1.6v-1L38 11v-1l1.4 1.7-.2-.9 1.4 1.8.7.8v.5h-.5l-1.2-.3-2.4-.7 1.2-.1L36 12h1l-2.3-.8h1l-2-.6H35l-2-.6 1-.1-1.7-.8 1.4.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.6 8.2 8.6 5.7m-4-1 2.8.2-.9-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 12 2.8.3-1-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.7 11.2 2.8.2-.8-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8 10.6h2.5l-.6-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8 10h2.6l-.6-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.2 9.1 2.5.5-1-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "m49.8 10-1.2 1 1.4.1-2 .5 1 .3-2 .1 1 .3-2 .2 1 .3-2.4.3 1 .3-2.4.3 1 .3-2.4.3-1.2.1-.5-.1.1-.5 1-.7 1.7-1.5-.4.9 1.8-1.5-.4.9 1.8-1.5-.4.9 1.5-1.4-.4 1 1.4-1.4-.4.9 1.6-1-.7 1 1.5-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.8 10-9.7 4.3m2.8-2.7-1.4 2 2.7.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3 11 43 13l2.7.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.7 10.4-1.5 2 2.8.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.8 10-1.2 1.9 2.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.8 9.5-1.1 2 2.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 9.3-1.6 1.8h2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "m49.6 19.2-1.5-.4.5 1-1.4-1.1.2.9-1.2-1.5.2 1-1.2-1.5.3.9-1.6-1.6.2.9-1.5-1.7.2 1-1.5-1.7-.8-.8-.1-.4.6-.1 1.2.2 2.4.6-1.1.2 2.4.5-1.1.2 2.4.5-1 .2 2 .4-1.1.1 2 .4-1 .2 1.8.6h-1.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.6 19.2-9.2-5m4.2.7h-2.9l1.1 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9 15.6H43l1.1 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2 16.3h-2.9l1.2 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.2 16.9-2.5.1.7 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.2 17.4-2.5.2.7 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 18.2-2.7-.3 1.3 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.2,
    d: "m33.6 19.7.8-1-1.2.1 1.4-.8h-.9l1.7-.6h-1l1.7-.7h-.9l2-.8h-1l2-.9h-1l1.9-.8 1-.4h.4v.4l-.5 1-1 1.6V16l-1 1.7v-.9l-1 1.7v-.9l-.8 1.6v-1l-.7 1.6v-.9l-1 1.3.3-1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.6 19.7 7-5.9m-1.7 3 .6-2.2-2.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 17.7.5-2.2-2.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 18.5.6-2.2-2.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.2 19.2.4-2-2.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.5 19.8.3-2-2 .1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.5 20.2.8-2-2.1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "m47.6 5.5-1.5 1-.2-1-1 1.4v-.7L44 7.7V7l-.6 1.6-.3-.8-.5 2-.4-.8-.5 1.9-.3-.8-.6 2-.3.9.2.3.6-.2 1-.7 2.1-1.6-1.2.4 2-1.5-1.1.4 2-1.6L45 9l2-1.2-1.4.4L47.8 7l-1.3.4L48 6l-1.4.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 6-2.1 2-4.2 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 11-2.4 1.2-.2-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.9 10-2.5 1-.2-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.7 8.8-2.4 1.1-.2-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.4 8-2.2.8-.3-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.3 7.1-2.4.8-.1-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.6 6.4-2.2 1 .4-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "m39.5 3.7.7 1.5.8-.8V6l.6-.5L41 7l.5-.5-.4 1.5.7-.5-.6 1.9.7-.5-.7 1.9.7-.5-.6 1.8-.4 1-.3.2-.4-.4-.5-1.1-.8-2.3.8.9-.8-2.3.7 1-.8-2.3.8.9-1-2 1 1-1.3-2 1 .9-.6-1.9.8 1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.7 4.4.7 2.5.3 6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.3 10 1.3 2 1.2-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.2 8.6 1.3 2 1.3-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.1 7.3 1.4 2L41.7 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 6.2 40.4 8l1.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.8 5.2 1.6 1.7 1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 4.4 1.2 2 .7-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.2,
    d: "m30.6 14.8 2-1.3-1-.5 1.7.3-.6-.8 1.6.6-.6-.8 1.7.7-.6-.8 2 .7-.6-.8 2 1-.6-.8 2 .7 1 .5.3.4-.4.3-1.1.1-1.7.7.3-.6-2.2.3.8-.5-2.2.6.8-.5-1.8.7.8-.9-2 1 1-.8-1.7 1 1-1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.2 14.5 2-1h4.9l2.8.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 14.7 1.5-1-1.6-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.2 14.6 1.9-1-1.6-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 14.6 1.7-1-1.6-1.2m-2.4 2.4 1.6-1.4-1.3-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 15 1.2-1.4-1-.4m1.5 1.5 1.6-1.3-1.2-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    fillRule: "evenodd",
    d: "M37.1 29.6v-2.3l-.6-1q-.2-.9.1-.8l1 .1c.3 0 .3-.6.8-.5l2.4.3c.9 0 1.3-.2 2.3-.3q1.3.2 1.3.4l.6-.2.3.1-.1 1-.6.8-.2 2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M44.7 27.3s.7-.5.7-1.8q0-1.1-1.3-1.2c-1.4 0-3.3.5-3.3.5v.2s1.6-.5 3.3-.5q1 .1 1.1 1c0 .9-.7 1.8-.7 1.8v1.4h.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m45 26.9.1.1h.3v-.2h-.2zm.2-.4v.1h.4v-.2h-.3zm.1-.5v.2h.4V26h-.3m0-.4v.1l.2.1h.2v-.2l-.2-.1zm0-.4v.1h.3V25h-.3m-.6 2.3v.1h.3V27h-.3zm.4-2.6v.1l.1.1h.3v-.3h-.3zm-.3-.3v.1h.3v-.2H45m-.6-.2v.1l.1.1h.2V24l-.1-.1zm-.4 0v.1h.3V24H44zm-.6 0v.1h.4V24h-.3zm-.4.1v.1h.2V24H43zm-.6.1.1.1h.2V24h-.2zm-.6 0v.1l.2.1h.1l.1-.1v-.2h-.3zm-.4.2.2.1h.1v-.3h-.3zm-4.8 2.4v.1h-.3v-.2zm-.2-.4v.1H36v-.2h.3zm-.1-.5v.2H36V26zm0-.4v.1l-.2.1h-.2v-.2l.2-.1h.1zm0-.4v.1h-.4v-.2h.3m.2-.4v.2H36v-.3h.3zm.4-.3v.1h-.4v-.2h.3m.6-.2v.1l-.2.1h-.2V24l.2-.1h.1zm.4 0v.1h-.3V24h.3zm.5 0v.1h-.3V24h.3zm.6.1v.1h-.4V24h.3zm.5.1-.1.1h-.3V24h.3zm.5 0v.1l-.1.1h-.2v-.3zm.5.2-.1.1H40v-.3h.2zm-3.4 2.8-.1.1h-.2V27h.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M37 27.3s-.7-.5-.7-1.8q-.1-1.1 1.3-1.2c1.3 0 3.2.5 3.2.5v.2s-1.5-.5-3.2-.5q-1.2.1-1.2 1c0 .9.8 1.8.8 1.8v1.4H37zm1.3.7.3-.2q.2 0 .3.3v.2-.2q0-.3.3-.3l.3.1s0-.4-.3-.4l-.2.1V27l-.2.3v.4h-.2q-.4.1-.3.3m3.9 0 .2-.2q.3 0 .3.3v.2h.1v-.2q0-.3.3-.3l.2.1s0-.4-.2-.4l-.3.1V27l-.2.3v.4h-.2q-.3.1-.2.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M37 29.7v-1.6s.4.6 1 .6c.4 0 1-.7 1-.7s.4.5.9.5 1-.7 1-.7.4.7.9.7 1-.5 1-.5.4.7 1 .7.9-.6.9-.6v1.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M37 29.7v-1.2s1.2.3 1.2 1.2zm7.6 0v-1.2s-1.1.3-1.1 1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M37.8 29.7c0-.9 1.1-1.4 1.1-1.4s1.2.5 1.2 1.4zm3.8 0c0-.9 1.1-1.4 1.1-1.4s1.2.5 1.2 1.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M39.5 29.7c0-.8 1.3-1.5 1.3-1.5s1.4.7 1.4 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M44.8 29.7q-.5-.2-4-.3-3.4 0-4 .3-.8.4 0 .7.6.4 4 .4 3.5 0 4-.4.6-.3 0-.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M44.7 30.4c0 .4-3.2.4-3.9.4s-3.8 0-3.8-.4c0-.3 3.2-.3 3.8-.3.7 0 3.9 0 3.9.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    fillRule: "evenodd",
    d: "m37.4 29.2-.2.2-.2-.2.2-.2q.2 0 .2.2m7.2 0-.1.2-.2-.2q0-.2.2-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M41.2 29q0 .3-.4.3-.3 0-.3-.2t.3-.2.4.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    fillRule: "evenodd",
    d: "M43 29q0 .3-.2.3t-.3-.2.3-.2.3.2m-3.9 0q0 .3-.3.3l-.3-.2q0-.2.3-.2t.3.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M40 27.9q.1-.2.5-.3h.2v.2q-.1.4-.3.4h.9s-.4-.1-.4-.4v-.2h.3l.4.3V27q0 .2-.4.3h-.3v-.2q.2-.6.4-.5h-.9l.3.5v.2h-.2q-.4-.1-.4-.3zm-3 .6h.2l-.1-.4V28l.3.2v-.7l-.2.3H37v-.2l.1-.3H37zm7.7 0h-.3q.1.1.2-.4V28h-.1l-.2.2v-.7l.2.3h.1v-.2l-.2-.3h.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M41 27.4v.2h-.3v-.2l.1-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M40 24.2q.1-.2.5-.3h.2v.2q-.1.4-.3.4h.9s-.4-.1-.4-.4v-.2h.3q.4.1.4.3v-.8l-.4.3h-.3v-.2q.2-.4.4-.4h-.9q.1-.1.3.4v.2h-.2l-.4-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M41 23.8v.1h-.3v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M40.5 24.5h.7v.5h-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    fillRule: "evenodd",
    d: "M40.5 24.7h.7v2h-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M41 26.4v.1h-.3v-.2zm0-.3h-.3V26l.1-.1h.2zm0-.5-.2.1h-.1v-.3zm0-.5v.2h-.3V25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M41.2 29.7q0 .2-.4.2-.3 0-.3-.2l.4-.1zm3.5.4h-.4q-.3 0-.3-.2h.4zm-1.4-.2h-.4l-.4-.1.4-.1q.4 0 .4.2m-6.5.2h.4l.4-.2h-.4zm1.6-.3.4.1q.4 0 .3-.1 0-.2-.4-.1-.4 0-.3.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.7 0h26.6v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.8 0 14 7.5 24 0h3.3v2.6l-10 7.4 10 7.5V20H24l-10-7.5L4 20H.7v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18.3 11.7 9 6.6V20L16 11.7zm-7.6.8.2 1.5-8 6H.7zM27.3 0v.1L17 8V6l8.3-6zM.7 0l10 7.3H8L.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.7 0v20h6.7V0zM.7 6.7v6.6h26.6V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.7 8v4h26.6V8zM12 0v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/io.cb1362f98d1695a844b72b8305af0a6c.svg";
export { ForwardRef as ReactComponent };